export default __webpack_public_path__ + "static/media/inbox-circle-tc.4a1b371b.svg";